import React, { Fragment } from 'react'
import { Form } from 'react-bootstrap'
import OrderSummary from '../../Components/Cart/OrderSummary'
import CheckoutScreen from '../../Components/Checkout'
import TopBanner from '../../Components/Main/TopBanner'

const Checkout = () => {
    return (
        <Fragment>
            <TopBanner title={"Checkout"} />
            <CheckoutScreen />
        </Fragment>
    )
}

export default Checkout